import createBaseService from "@/api/base-service.ts";
import type { Project } from "../../types/project";

const projectService = {
	...createBaseService<Project>("/projects"),

	async search(searchTerm = ""): Promise<{ data: Project[] }> {
		const response = await fetch(`/api/projects?search=${encodeURIComponent(searchTerm)}`);
		return response.json();
	},

	async grouped(params: Record<string, unknown> = {}): Promise<{
		grouped_by: string;
		groups: Array<{
			group: string;
			count: number;
			projects: Project[];
		}>;
	}> {
		const searchParams = new URLSearchParams();
		for (const [key, value] of Object.entries(params)) {
			if (value !== undefined && value !== null) {
				searchParams.append(key, String(value));
			}
		}

		const response = await fetch(`/api/projects/grouped?${searchParams}`);
		return response.json();
	},
};

export default projectService;
